import React, { useEffect, useState } from 'react'
import { CheckoutLeftSection, CheckoutRightSection } from '../components'
import { getAllCartItems } from '../api'
import { setCartItems } from '../context/actions/cartActions'
import { useDispatch, useSelector } from 'react-redux'

const CheckoutContainer = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const [retryCount, setRetryCount] = useState(0);
    useEffect(() => {
        const fetchData = async () => {
          try {
            const data = await getAllCartItems(user?.user_id);
            dispatch(setCartItems(data));
          } catch (error) {
            console.error('Error fetching cart items:', error);
            // Retry fetching after a delay (e.g., 3 seconds)
            if (retryCount < 3) {
              setTimeout(() => {
                setRetryCount(prevCount => prevCount + 1);
              }, 3000);
            } else {
              console.log('Max retry attempts reached');
            }
          }
        };
    
        if (retryCount === 0) {
          fetchData();
        }
      }, [retryCount, user?.user_id, dispatch]);

    return (
        <div className="w-full h-auto flex gap-3 justify-between mt-10 md:flex-row flex-col-reverse">
            <CheckoutLeftSection />
            <CheckoutRightSection />
        </div>
    )
}

export default CheckoutContainer